import { Skeleton, } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import 'flowbite';
import { Helmet } from 'react-helmet';
import fetchRelation from "../utils/fetchCategorie";
import { URLOeuvreId, URLimage } from "../utils/varaibleFetch";
import EmojiFlagsIcon from '@mui/icons-material/EmojiFlags';
import Coments from "../component/oeuvreid/coment";
import SocialMedia from "../component/oeuvreid/social/socialMedia";
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import PaletteIcon from '@mui/icons-material/Palette';
import DateRangeIcon from '@mui/icons-material/DateRange';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import CloseIcon from '@mui/icons-material/Close';
interface Like {
  id: number;

}
interface Post {
  name: string;
  description: string;
  image: string;
  categorie: string;
  theme: string;
  id: number;
  likes: Like[];

}

interface ArtworkSummary {
  id: number;
  name: string;
}

const ArticleDetailPage: React.FC = () => {
  const [post, setPost] = useState<Post | null>(null);
  const [artworks, setArtworks] = useState<ArtworkSummary[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [categoryName, setCategoryName] = useState<string>("");
  const [themeName, setThemeName] = useState<string>("");
  const [selectedImage, setSelectedImage] = useState<string>("");
  const [fullscreenOpen, setFullscreenOpen] = useState(false);
  const [pageUrl, setPageUrl] = useState("");
  const params = useParams<{ id: string; category: string }>();

  useEffect(() => {
    setPageUrl(window.location.href);
  }, [params.id]);

  useEffect(() => {
    const fetchArtworks = async () => {
      try {
        const res = await fetch(URLOeuvreId);
        if (!res.ok) {
          throw new Error('Failed to fetch artworks');
        }
        const data = await res.json();
        const apiArtworks = data["hydra:member"] || data.member || data || [];
        setArtworks(apiArtworks.map((artwork: ArtworkSummary) => ({
          id: artwork.id,
          name: artwork.name,
        })));
      } catch (error) {
        console.error(error);
      }
    };

    fetchArtworks();
  }, []);
  const fetchPost = async (id: number) => {
    setIsLoading(true);
    setSelectedImage("");
    try {
      const res = await fetch(`${URLOeuvreId}/${id}`);
      if (!res.ok) {
        throw new Error('Failed to fetch article');
      }
      const postData = await res.json();

      setPost(postData);
      fetchRelation(postData.theme, setThemeName);
      fetchRelation(postData.categorie, setCategoryName);
      setIsLoading(false); // Mettre à jour l'état de chargement après avoir récupéré les données
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const postId = Number(params.id);
    if (!isNaN(postId)) {
      fetchPost(postId);
    }
  }, [params.id]);

  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        setFullscreenOpen(false);
      }
    };

    document.body.style.overflow = fullscreenOpen ? "hidden" : "";
    document.addEventListener("keydown", handleEscape);

    return () => {
      document.body.style.overflow = "";
      document.removeEventListener("keydown", handleEscape);
    };
  }, [fullscreenOpen]);

  const handleClickImage = (imageUrl: string) => {
    setSelectedImage(imageUrl);
  };

  const imageSrc = post ? `${URLimage}/${post.image}` : "";
  const activeImage = selectedImage || imageSrc;
  const showRoomPreview = selectedImage === "../images/large.jpg";
  const galleryPath = post?.categorie?.endsWith("/2") || categoryName.toLowerCase().includes("digital")
    ? "/digital"
    : "/peinture";
  const currentArtworkIndex = post ? artworks.findIndex((artwork) => artwork.id === post.id) : -1;
  const previousArtwork = currentArtworkIndex > 0 ? artworks[currentArtworkIndex - 1] : null;
  const nextArtwork = currentArtworkIndex >= 0 && currentArtworkIndex < artworks.length - 1
    ? artworks[currentArtworkIndex + 1]
    : null;

  return (
    <section className="artwork-detail">
      <Helmet>
        <meta property="og:type" content="website" />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:title" content={post ? post.name : 'Chargement...'} />
        <meta property="og:description" content={post ? post.description : 'Chargement de l\'œuvre...'} />
        <meta property="og:image" content={post ? imageSrc : "/images/accueil/bp.png" } />
      </Helmet>

      {post && (
        <>
          <Link className="artwork-detail__back focus-ring" to={galleryPath}>
            <ArrowBackIcon fontSize="small" />
            Retour Galerie
          </Link>
        </>
      )}

      {isLoading || !post ? (
        <div className="artwork-detail__loading">
          <Skeleton sx={{ bgcolor: 'grey.900' }} variant="rectangular" width="64%" height="70%" />
          <Skeleton sx={{ bgcolor: 'grey.900' }} variant="rectangular" width="28%" height="70%" />
        </div>
      ) : (
        <div className="artwork-detail__grid">
          <div className="artwork-detail__visual">
            <div className="artwork-detail__image-stage">
              <figure className="artwork-detail__frame image-frame">
                <img src={activeImage} alt={post.name} />
                {showRoomPreview && (
                  <img className="artwork-detail__room-preview" src={imageSrc} alt={post.name} />
                )}
              </figure>
              <button
                className="artwork-detail__fullscreen focus-ring"
                onClick={() => setFullscreenOpen(true)}
                type="button"
              >
                <FullscreenIcon fontSize="small" />
                Plein écran
              </button>
            </div>
            <SocialMedia
              postImage={post.image}
              URLimage={URLimage}
              onclick={() => handleClickImage(imageSrc)}
              onclick2={() => handleClickImage('../images/large.jpg')}
              likeButton={post.likes ? post.likes.length : 0}
              post={post.id}
              pageUrl={pageUrl}
            />
          </div>

          <aside className="surface-panel artwork-detail__panel">
            <p className="mono-label">Oeuvre</p>
            <h1 className="art-title neon-title">{post.name}</h1>
            <p className="artwork-detail__description">{post.description}</p>

            <dl className="artwork-detail__meta">
              <div>
                <dt>Titre</dt>
                <dd>{post.name}</dd>
              </div>
              <div>
                <dt>Categorie</dt>
                <dd>{categoryName}</dd>
              </div>
              <div>
                <dt>Theme</dt>
                <dd>{themeName}</dd>
              </div>
            </dl>

            <div className="artwork-detail__features">
              <div><PaletteIcon fontSize="small" /> Oeuvre unique</div>
              <div><EmojiFlagsIcon fontSize="small" /> Certificat inclus</div>
              <div><FingerprintIcon fontSize="small" /> Signe par l'artiste</div>
              <div><DateRangeIcon fontSize="small" /> Pret a accrocher</div>
            </div>

            <Coments />
          </aside>

          <nav className="artwork-detail__nav" aria-label="Navigation entre les oeuvres">
            {previousArtwork ? (
              <Link className="artwork-detail__nav-link artwork-detail__nav-link--prev focus-ring" to={`/oeuvre/${previousArtwork.id}`}>
                <span className="artwork-detail__nav-arrow" aria-hidden="true">
                  <ArrowBackIcon fontSize="small" />
                </span>
                <span className="artwork-detail__nav-content">
                  <span className="artwork-detail__nav-label">Précédent</span>
                  <span className="artwork-detail__nav-title">{previousArtwork.name}</span>
                </span>
              </Link>
            ) : (
              <span className="artwork-detail__nav-link artwork-detail__nav-link--prev artwork-detail__nav-link--disabled">
                <span className="artwork-detail__nav-arrow" aria-hidden="true">
                  <ArrowBackIcon fontSize="small" />
                </span>
                <span className="artwork-detail__nav-content">
                  <span className="artwork-detail__nav-label">Précédent</span>
                  <span className="artwork-detail__nav-title">Première oeuvre</span>
                </span>
              </span>
            )}

            {nextArtwork ? (
              <Link className="artwork-detail__nav-link artwork-detail__nav-link--next focus-ring" to={`/oeuvre/${nextArtwork.id}`}>
                <span className="artwork-detail__nav-content">
                  <span className="artwork-detail__nav-label">Suivant</span>
                  <span className="artwork-detail__nav-title">{nextArtwork.name}</span>
                </span>
                <span className="artwork-detail__nav-arrow" aria-hidden="true">
                  <ArrowForwardIcon fontSize="small" />
                </span>
              </Link>
            ) : (
              <span className="artwork-detail__nav-link artwork-detail__nav-link--next artwork-detail__nav-link--disabled">
                <span className="artwork-detail__nav-content">
                  <span className="artwork-detail__nav-label">Suivant</span>
                  <span className="artwork-detail__nav-title">Dernière oeuvre</span>
                </span>
                <span className="artwork-detail__nav-arrow" aria-hidden="true">
                  <ArrowForwardIcon fontSize="small" />
                </span>
              </span>
            )}
          </nav>
        </div>
      )}

      {fullscreenOpen && post && (
        <div
          className="artwork-detail__fullscreen-modal"
          onClick={() => setFullscreenOpen(false)}
          role="dialog"
          aria-modal="true"
          aria-label={`Vue plein écran de ${post.name}`}
        >
          <button
            className="artwork-detail__fullscreen-close focus-ring"
            onClick={() => setFullscreenOpen(false)}
            type="button"
            aria-label="Fermer le plein écran"
          >
            <CloseIcon fontSize="small" />
          </button>
          <div className="artwork-detail__fullscreen-frame" onClick={(event) => event.stopPropagation()}>
            <img src={activeImage} alt={`${post.name} - vue plein écran`} />
            {showRoomPreview && (
              <img className="artwork-detail__fullscreen-room-preview" src={imageSrc} alt={`${post.name} dans la pièce`} />
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default ArticleDetailPage;
